import client from './client'

const fetchSliders = () => {
  return client.get('/items/sliders', {
    fields: [
      'key',
      'title',
      'slides.*',
      'slides.file.data.*',
      'slides.file.width',
      'slides.file.height',
    ],
  })
}

export default fetchSliders
